import { isShowNews1 } from "@/utils/isShowNews1";
import {
  DailyDetailMiddleAd,
  DailyDetailTopAd,
  DailyListContentAd,
  shouldRenderAdForDomains,
  shouldShowWiAdOnly,
} from "./shared";

export function useAdCpt1(position: string): JSX.Element | null {
  const googleAd1Props1 = useGoogleAd1("ad1", 4);
  const googleAd1Props3 = useGoogleAd1("ad1", 5);
  const googleAd1Props5 = useGoogleAd1("ad1", 6);

  switch (position) {
    case "position-27":
      if (shouldShowWiAdOnly()) {
        return <GoogleAd1 dataPosition={position} {...googleAd1Props1} />;
      }
      return null;
    case "position-40":
      return <DailyDetailTopAd position={position} />;
    case "position-28":
      if (shouldShowWiAdOnly()) {
        return <GoogleAd1 dataPosition={position} {...googleAd1Props3} />;
      }
      return null;
    case "position-37":
      return <DailyDetailMiddleAd position={position} yanDexIndex={2} googleAd2Index={2} />;
    case "position-29":
      if (shouldShowWiAdOnly()) {
        return <GoogleAd1 dataPosition={position} {...googleAd1Props5} />;
      }
      return null;
    case "position-38":
      return <DailyDetailMiddleAd position={position} yanDexIndex={3} googleAd2Index={3} />;
    default:
      return null;
  }
}

export function useAdCpt2(position: string, pathname: string): JSX.Element | null {
  const { hostName } = useHostName();
  const wiDomains = domainMap["wi"] || [];
  const shouldRenderAd1 = shouldRenderAdForDomains(hostName, wiDomains);
  const isNewsPage = isShowNews1().validMain;

  const googleAd1Ad1Index2 = useGoogleAd1("ad1", 2);
  const googleAd1Ad3Index0 = useGoogleAd1("ad3", 0);

  switch (position) {
    case "position-24":
      if (!isNewsPage && shouldRenderAd1) {
        return <GoogleAd1 dataPosition={position} {...googleAd1Ad1Index2} />;
      }
      if (wgDomains1.includes(hostName) && pathname === "/daily") {
        return <GoogleAd1 dataPosition={position} {...googleAd1Ad3Index0} />;
      }
      return null;

    case "position-09":
      return <DailyListContentAd position={position} />;

    default:
      return null;
  }
}
